/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Contact_Code_Type_RadioInputs */

const en_enum_contact_code_type_radio = /** @type {(inputs: Enum_Contact_Code_Type_RadioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code Type Radio`)
};

const de_enum_contact_code_type_radio = /** @type {(inputs: Enum_Contact_Code_Type_RadioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code Typ Radio`)
};

/**
* | output |
* | --- |
* | "Code Type Radio" |
*
* @param {Enum_Contact_Code_Type_RadioInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_contact_code_type_radio = /** @type {((inputs?: Enum_Contact_Code_Type_RadioInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Contact_Code_Type_RadioInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_contact_code_type_radio(inputs)
	return de_enum_contact_code_type_radio(inputs)
});